import AccountLockedPage from "pages/account-locked";
import DashboardPage from "pages/dashboard";
import EmailVerifyPage from "pages/email-verify";
import ForgetPasswordPage from "pages/forget-password";
import LoginPage from "pages/login";
import ResetPasswordPage from "pages/reset-password";
import SignUpPage from "pages/signup";
import VerifiedEmailLinkPage from "pages/verification-expired";
import { useSelector } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { authActions } from "../redux/slice/auth.slice";
import PrivateLayoutRoutes from "./PrivateLayoutRoutes";


const MyRouter = () => {
  const auth = useSelector(authActions.selectors.getLoggedInStatus);
  return (
    <Router>
      <Routes>
        <Route element={<PrivateLayoutRoutes auth={auth}/>}>
          <Route path="/" element={<DashboardPage />} />
        </Route>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forget-password" element={<ForgetPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/sign-up" element={<SignUpPage />} />
        <Route path="/email-verify" element={<EmailVerifyPage />} />
        <Route path="/verification-expired" element={<VerifiedEmailLinkPage />} />
        <Route path="/account-locked" element={<AccountLockedPage />} />
      </Routes>
    </Router>
  );
};

export default MyRouter;
